import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './QuoteDisplay.css';
import GurapalabQuote from './quotes/GurapalabQuote';
import ConnaraQuote from './quotes/ConnaraQuote';

const componentMap = {
  gurapalab: GurapalabQuote,
  connara: ConnaraQuote,
};

export default function QuoteDisplay() {
  const { code } = useParams();
  const navigate = useNavigate();
  const Component = componentMap[code];

  if (!Component) {
    return (
      <div className="quote-display-container">
        <h2>Quote Not Found</h2>
        <p>The access code you provided is not valid.</p>
        <button onClick={() => navigate('/b2b/quote')}>Try Again</button>
      </div>
    );
  }

  return <Component />;
}